export default {
  "mainVegetable": "zarzavate",
  "mainVegetable/01": "zarzavate/patellxan",
  "mainVegetable/02": "zarzavate/sparg",
  "mainVegetable/03": "zarzavate/avokado",
  "mainVegetable/04": "zarzavate/panxar",
  "mainVegetable/05": "zarzavate/brokoli",
  "mainVegetable/06": "zarzavate/karota",
  "mainVegetable/07": "zarzavate/selino",
  "mainVegetable/08": "zarzavate/kerpuda",
  "mainVegetable/09": "zarzavate/laker",
  "mainVegetable/10": "zarzavate/laker-brukseli",
  "mainVegetable/11": "zarzavate/laker-kineze",
  "mainVegetable/12": "zarzavate/lulelaker",
  "mainVegetable/13": "zarzavate/laker-tursi",
  "mainVegetable/14": "zarzavate/kastravec",
  "mainVegetable/15": "zarzavate/kungulleska",
  "mainVegetable/16": "zarzavate/cikore",
  "mainVegetable/17": "zarzavate/spinaq",
  "mainVegetable/18": "zarzavate/fasule-fava",
  "mainVegetable/19": "zarzavate/fasule-te-zakonsme",
  "mainVegetable/20": "zarzavate/bistaja-te-sesta",
  "mainVegetable/21": "zarzavate/fasule-te-tata",
  "mainVegetable/22": "zarzavate/bistaja-te-gelbra",
  "mainVegetable/23": "zarzavate/tjereza",
  "mainVegetable/24": "zarzavate/zarzavate-te-prera-kubike",
  "mainVegetable/25": "zarzavate/miser",
  "mainVegetable/26": "zarzavate/sallate-mikse",
  "mainVegetable/27": "zarzavate/repa",
  "mainVegetable/28": "zarzavate/qepe",
  "mainVegetable/29": "zarzavate/soje",
  "mainVegetable/30": "zarzavate/speca",
  "mainVegetable/31": "zarzavate/patate",
  "mainVegetable/32": "zarzavate/bimeza-soje",
  "mainVegetable/33": "zarzavate/repka",
  "mainVegetable/34": "zarzavate",
  "mainVegetable/35": "zarzavate/cikore-e-dredur",
  "mainVegetable/36": "zarzavate/sallata-ajsberg",
  "mainVegetable/37": "zarzavate/sallata-piemonteze",
  "mainVegetable/38": "zarzavate/sallate-orizi",
  "mainVegetable/39": "zarzavate",
  "mainVegetable/40": "zarzavate/filizat",
  "mainVegetable/41": "zarzavate/sallate-jesile",
  "mainVegetable/42": "zarzavate/marulja-e-qengit",
  "mainVegetable/43": "zarzavate/rukola",
  "mainVegetable/44": "zarzavate",
  "mainVegetable/45": "zarzavate",
  "mainVegetable/46": "zarzavate/domate",
  "mainVegetable/47": "zarzavate/fasule-pllaqi",
  "mainVegetable/48": "zarzavate/qiqra",
  "mainVegetable/49": "zarzavate/pres",
  "mainVegetable/50": "zarzavate/kungull",
  "mainVegetable/51": "zarzavate/fasule-e-kuqe",
  "mainVegetable/52": "zarzavate/molle",
  "mainVegetable/53": "zarzavate/gestena",
  "mainVegetable/54": "zarzavate/kumbulla-te-tata",
  "mainVegetable/55": "zarzavate",
  "mainVegetable/56": "zarzavate/ullin-te-zin",
  "mainVegetable/57": "zarzavate/articoke",
  "mainVegetable/58": "zarzavate/speca-te-kuq",
  "mainVegetable/59": "zarzavate/bistaja-te-sesta-te-gelbra",
  "mainVegetable/60": "zarzavate",
  "mainVegetable/61": "zarzavate/ratatouille-turli-ne-tave",
  "mainVegetable/62": "zarzavate/kuskus",
  "mainVegetable/63": "zarzavate",
  "mainVegetable/64": "zarzavate/zarzavate-per-keri",
  "mainVegetable/65": "zarzavate",
  "mainVegetable/66": "zarzavate",
  "mainVegetable/67": "zarzavate/tjereza-te-kuqe",
  "mainVegetable/68": "zarzavate/kuinoa",
  "mainVegetable/69": "zarzavate/grure-spelt",
  "mainVegetable/70": "zarzavate/bullgur",
  "mainVegetable/71": "zarzavate/laker-e-kuqe",
  "mainVegetable/72": "zarzavate/laker-jesilekale",
  "mainVegetable/73": "zarzavate/majdanoz",
  "mainVegetable/74": "zarzavate/dritera-de-farera",
  "mainVegetable/75": "zarzavate/bistajore",
  "mainVegetable/76": "zarzavate/patate-e-embel",
  "mainVegetable/77": "zarzavate/kunguj",
  "mainVegetable/78": "zarzavate/brume",
  "mainVegetable/79": "zarzavate/fasule",
  "mainVegetable/80": "zarzavate/bizele-karote",
  "mainVegetable/81": "zarzavate/bizele",
  "mainVegetable/82": "zarzavate/edamame",
  "mainVegetable/83": "zarzavate/elb",
  "mainVegetable/84": "zarzavate/miks-sallate",
  "mainVegetable/85": "zarzavate/cikore-e-embel",
  "mainVegetable/86": "zarzavate",
  "mainVegetable/87": "zarzavate/spinaq-i-nome",
  "mainVegetable/88": "zarzavate/marule-getevogel",
  "mainVegetable/89": "zarzavate/repa-zvicerane",
  "mainVegetable/90": "zarzavate/pastinak",
  "mainVegetable/91": "zarzavate/oriz-i-zi",
  "mainVegetable/92": "zarzavate/miks-fasules",
  "mainVegetable/93": "zarzavate/fasule-te-zeza",
  "mainVegetable/94": "zarzavate/laker-me-maje",
  "mainVegetable/95": "zarzavate/fasule-te-barda",
  "mainVegetable/96": "zarzavate/domate-te-tara",
  "mainVegetable/97": "zarzavate/miks-zarzavates",
  "mainVegetable/98": "zarzavate/kungull-dimri",
  "productRange": "gama",
  "productRange/4G_BIO": "gama",
  "productRange/4G_SRP": "gama",
  "productRange/CAN_A_POEL": "gama",
  "productRange/CAN_SEC_BI": "gama",
  "productRange/CAN_SEC_CO": "gama",
  "productRange/CAN_SEC_CU": "gama",
  "productRange/CAN_SEC_NA": "gama",
  "productRange/CAN_VAPEUR": "gama",
  "productRange/CAN_VEG_SA": "gama",
  "productRange/CAN_VEG_SR": "gama",
  "productRange/CLASSICVEG": "gama",
  "productRange/COLDVEGE": "gama",
  "productRange/COOKMUSH": "gama",
  "productRange/CRUDITES": "gama",
  "productRange/DE_NOS_PRO": "gama",
  "productRange/DOYMUSHACC": "gama",
  "productRange/DOYMUSHAPE": "gama",
  "productRange/DRYVEGE": "gama",
  "productRange/FROZENVEGE": "gama",
  "productRange/FRZ_ASTUCE": "gama",
  "productRange/FRZ_GRATIN": "gama",
  "productRange/FRZ_KELLO": "gama",
  "productRange/FRZ_LEG_CO": "gama",
  "productRange/FRZ_PUREES": "gama",
  "productRange/FRZ_VEG_BI": "gama",
  "productRange/FRZ_VEG_SR": "gama",
  "productRange/INDFROZVEG": "gama",
  "productRange/JEUNES_POU": "gama",
  "productRange/LAITUES": "gama",
  "productRange/LOOP": "gama",
  "productRange/LUNCH_BOWL": "gama",
  "productRange/MACHE_BASE": "gama",
  "productRange/MEL_LAITUE": "gama",
  "productRange/MUSHNATEMI": "gama",
  "productRange/MUSHNATENT": "gama",
  "productRange/MUSHNATEPA": "gama",
  "productRange/MUSHNATMIN": "gama",
  "productRange/MUSHROOMS": "gama",
  "productRange/SUNVEGE": "gama",
  "productRange/TRAIT_CRUD": "gama",
  "productRange/TRAIT_TABO": "gama",
  "productRange/TUS_RECETA": "gama",
  "productRange/WORLDVEGE": "gama",
  "productRange/PREPARED_VEG": "gama",
  "productRange/BEAN_SAUCE": "gama/fasule-me-salce",
  "productRange/BEANS": "gama/fasule",
  "productRange/BIO": "gama/bio",
  "productRange/BOND_KIDS": "gama/bonduelle-kids",
  "productRange/CAN_BIO": "gama/bio-perimet",
  "productRange/CAN_SEC_PR": "gama/perime-te-gatsme",
  "productRange/CARTA_DELL": "gama/carta-delle-insalate",
  "productRange/CAN_PETITS": "gama",
  "productRange/CAN_BOCAL": "gama",
  "productRange/CEREAL_CAN": "gama/dritera-ambienti",
  "productRange/CEREAL_FRZ": "gama/dritera-te-ngrira",
  "productRange/CEREALI": "gama/dritera",
  "productRange/CEREALLEGR": "gama/cereallegre",
  "productRange/COCCOLE": "gama/coccole",
  "productRange/CORN": "gama/miser",
  "productRange/CREATIF": "gama/creatif",
  "productRange/FRANCAIS": "gama/100-french",
  "productRange/FRZ_FRY_MI": "gama/perzierjet-e-perimeve-te-ngrira-per-tigan",
  "productRange/FRZ_MELANG": "gama/perime-te-perziera",
  "productRange/FRZ_POELEE": "gama",
  "productRange/INSALATE_D": "gama/insalate-degli-agricoltori",
  "productRange/INSALATONA": "gama/insalatona-piu",
  "productRange/LE_REGIONA": "gama/le-regionali",
  "productRange/LEGUMIO": "gama/legumio",
  "productRange/MIXES_CORN": "gama/perzierje-me-miser",
  "productRange/MONO_VEGE": "gama/zarzavate-te-ne-lloji",
  "productRange/MUSHROOMS  ": "gama/kerpuda",
  "productRange/NATURA_IN": "gama/natura-in-padella",
  "productRange/OTHER_VEG": "gama/zarzavate-te-tjera",
  "productRange/PEAS": "gama/bizele",
  "productRange/READY_FROZ": "gama/vakte-te-gatsme-te-ngrira",
  "productRange/SOUPS": "gama/zarzavate-per-supe",
  "productRange/SPINACH": "gama/spinaq",
  "productRange/STEAM_CAN": "gama/avull-kuti-konserve",
  "productRange/STEAM_FRZ": "gama/avull-te-ngrira",
  "productRange/STEAM_MIX": "gama/mikse-te-gatuara-ne-avull-te-ngrira",
  "productRange/STUZZICHIA": "gama/ngacmues",
  "productRange/TOUCHE": "gama/pasurues",
  "productRange/TRAIT_SAL": "gama/per-sallaten-tuaj",
  "productRange/TUS_RECETA ": "gama/recetat-tuaja",
  "productRange/VEG_TO_FRY": "gama/zarzavate-per-skuqje",
  "productRange/VEGGIE": "gama/oriz-me-perime",
  "productRange/FRZ_JUSTEA": "gama",
  "productRange/SALABIS": "gama",
  "productRange/BON_SENGAG": "gama",
  "productRange/CROUSTIS": "gama",
  "season": "stinet",
  "season/1": "stinet/vere",
  "season/2": "stinet/vjeste",
  "season/3": "stinet/dimer",
  "season/4": "stinet/pranvere",
  "season/5": "stinet",
  "technologie": "teknologia",
  "technologie/AC01": "teknologia/konserve",
  "technologie/AD01": "teknologia/ngrirje",
  "technologie/AG01": "teknologia/fresketa",
  "technologie/AT01": "teknologia/te-gatsme",
  "recipeDish": "lloji-i-pjates",
  "recipeDish/ACC": "lloji-i-pjates/soqeruese-garniture",
  "recipeDish/APE": "lloji-i-pjates/aperitiv",
  "recipeDish/DES": "lloji-i-pjates/embelsire",
  "recipeDish/ENT": "lloji-i-pjates/pjata-e-pare",
  "recipeDish/PLAT": "lloji-i-pjates/pjate",
  "recipeDish/SAL": "lloji-i-pjates/sallate",
  "recipeDish/SNA": "lloji-i-pjates/vakte-te-lehta",
  "recipeDish/PDE": "lloji-i-pjates/menges",
  "recipeDish/DEJ": "lloji-i-pjates/dreke",
  "recipeDish/TRA": "lloji-i-pjates/tradicional",
  "recipeDish/GOU": "lloji-i-pjates/usqim-gourmet",
  "recipeDish/ETH": "lloji-i-pjates/etnik",
  "recipeDish/FCH": "lloji-i-pjates/per-femije",
  "recipeDish/SOU": "lloji-i-pjates/supe",
  "pred-recipeTimingCook-facet": "pjekje",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "pjekje/0-15-minuta",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "pjekje/15-30-minuta",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "pjekje/30-45-minuta",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "pjekje/45-minuta",
  "pred-recipeTimingPreparation-facet": "pergatitja",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "pergatitja/0-15-minuta",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "pergatitja/15-30-minuta",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "pergatitja/30-45-minuta",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "pergatitja/45-minuta",
  "pred-recipeCost-Facet": "buxeti",
  "pred-recipeCost-Facet/petit": "buxeti/i-lire",
  "pred-recipeCost-Facet/moyen": "buxeti/mesatar",
  "pred-recipeCost-Facet/grand": "buxeti/i-larte",
  "recipeDifficulty": "pergatitja",
  "recipeDifficulty/1": "pergatitja/e-lehte",
  "recipeDifficulty/2": "pergatitja/mesatare",
  "recipeDifficulty/3": "pergatitja/e-nderlikuar",
  "recipeDishNumber": "racionet",
  "recipeDishNumber/1": "racionet/1",
  "recipeDishNumber/2": "racionet/2",
  "recipeDishNumber/3": "racionet/3",
  "recipeDishNumber/4": "racionet/4",
  "recipeDishNumber/5": "racionet/5",
  "recipeDishNumber/6": "racionet/6",
  "recipeDishNumber/7": "racionet/7",
  "recipeDishNumber/8": "racionet/8",
  "productTheme": "produktet-sipas-kategorise",
  "productTheme/ACC": "produktet-sipas-kategorise/soqeruese-garniture",
  "productTheme/BEA": "produktet-sipas-kategorise/fasule",
  "productTheme/BIS": "produktet-sipas-kategorise/fasule-me-salce",
  "productTheme/BIO": "produktet-sipas-kategorise/bio",
  "productTheme/CAN": "produktet-sipas-kategorise/usqim-i-konservuar",
  "productTheme/CER": "produktet-sipas-kategorise/dritera",
  "productTheme/CLS": "produktet-sipas-kategorise/klasike",
  "productTheme/DLE": "produktet-sipas-kategorise/zarzavate",
  "productTheme/EDR": "produktet-sipas-kategorise/pasurues-sijeje",
  "productTheme/ENT": "produktet-sipas-kategorise/pjata-e-pare",
  "productTheme/FRZ": "produktet-sipas-kategorise/te-ngrira",
  "productTheme/FSD": "produktet-sipas-kategorise/per-sallate",
  "productTheme/FSH": "produktet-sipas-kategorise/spenzime",
  "productTheme/ING": "produktet-sipas-kategorise/perberes-per-recetat-e-mia",
  "productTheme/JAR": "produktet-sipas-kategorise/zarzavate-ne-vazo",
  "productTheme/LBW": "produktet-sipas-kategorise/pjate-dreke",
  "productTheme/LDF": "produktet-sipas-kategorise/zarzavate-ne-fure",
  "productTheme/LEG": "produktet-sipas-kategorise/bistajore",
  "productTheme/LGO": "produktet-sipas-kategorise/legumio",
  "productTheme/LGR": "produktet-sipas-kategorise/zarzavate-ne-skare",
  "productTheme/LGS": "produktet-sipas-kategorise/zarzavate-per-supe",
  "productTheme/MAI": "produktet-sipas-kategorise/miser",
  "productTheme/MUS": "produktet-sipas-kategorise/kerpuda",
  "productTheme/NEW": "produktet-sipas-kategorise/produkte-te-reja",
  "productTheme/PDH": "produktet-sipas-kategorise/pjata-me-zarzavate-te-tara",
  "productTheme/PDL": "produktet-sipas-kategorise/sporte-zarzavates",
  "productTheme/PHR": "produktet-sipas-kategorise/makarona-de-makarona",
  "productTheme/PLP": "produktet-sipas-kategorise/pjata-kryesore",
  "productTheme/RAL": "produktet-sipas-kategorise/oriz-me-perime",
  "productTheme/RDM": "produktet-sipas-kategorise/pjata-kuzine",
  "productTheme/SAL": "produktet-sipas-kategorise/per-te-gita-pagat-e-mia",
  "productTheme/SDB": "produktet-sipas-kategorise/tasa-sallate",
  "productTheme/SNK": "produktet-sipas-kategorise/vakte-te-lehta",
  "productTheme/SUP": "produktet-sipas-kategorise/supe",
  "productTheme/TEX": "produktet-sipas-kategorise/tex-mex",
  "productTheme/VGP": "produktet-sipas-kategorise/proteina-perimes",
  "recipeTheme": "receta-sipas-temes",
  "recipeTheme/01": "receta-sipas-temes/receta-festive",
  "recipeTheme/02": "receta-sipas-temes/aperitiv",
  "recipeTheme/03": "receta-sipas-temes/sallata-de-vakte-te-lehta",
  "recipeTheme/04": "receta-sipas-temes/supa-de-gaspaco-supe-e-ftohte",
  "recipeTheme/05": "receta-sipas-temes/tarte-e-kripur-kek-de-tarta-me-djate",
  "recipeTheme/06": "receta-sipas-temes/speciale-per-femije",
  "recipeTheme/07": "receta-sipas-temes/embelsira",
  "recipeTheme/08": "receta-sipas-temes/vegetariane",
  "recipeTheme/09": "receta-sipas-temes/soqeruese",
  "recipeTheme/10": "receta-sipas-temes/nga-larg",
  "recipeTheme/11": "receta-sipas-temes/gelle",
  "recipeTheme/12": "receta-sipas-temes/sallata-de-skare",
  "recipeTheme/13": "receta-sipas-temes/vakte-te-lehta-de-fingerfood",
  "recipeTheme/14": "receta-sipas-temes/pjata-kryesore",
  "recipeTheme/15": "receta-sipas-temes/embelsira-de-pasta",
  "recipeTheme/16": "receta-sipas-temes/pjata-e-pare-de-supa",
  "recipeTheme/17": "receta-sipas-temes/sallata",
  "recipeTheme/18": "receta-sipas-temes/tasa",
  "recipeTheme/19": "receta-sipas-temes/supa",
  "recipeTheme/20": "receta-sipas-temes/vakte-te-lehta",
  "recipeTheme/21": "receta-sipas-temes/salce",
  "recipeTheme/22": "receta-sipas-temes/pjata-te-vetme",
  "recipeTheme/23": "receta-sipas-temes/pjata-te-tjera",
  "recipeTheme/24": "receta-sipas-temes/pjata-ne-fure",
  "recipeTheme/25": "receta-sipas-temes/meksikane",
  "recipeTheme/26": "receta-sipas-temes/ret-botes",
  "recipeTheme/27": "receta-sipas-temes/ne-dite-pa-mis",
  "recipeTheme/28": "receta-sipas-temes/karbohidrate-te-uleta",
  "recipeTheme/33": "receta-sipas-temes/baza-e-lenteve",
  "recipeTheme/34": "receta-sipas-temes/baze-lulelaker",
  "recipeTheme/35": "receta-sipas-temes/baze-patate",
  "recipeTheme/36": "receta-sipas-temes/baze-karote",
  "recipeTheme/37": "receta-sipas-temes/baze-spinaqi",
  "recipeTheme/38": "receta-sipas-temes/baza-e-specave",
  "recipeTheme/39": "receta-sipas-temes/baze-kerpudas",
  "recipeTheme/40": "receta-sipas-temes/baza-e-bistajave-te-sesta",
  "recipeTheme/41": "receta-sipas-temes/baze-misri",
  "recipeTheme/42": "receta-sipas-temes/bizele-baze",
  "recipeTheme/43": "receta-sipas-temes/baze-fasule-te-kuqe",
  "recipeTheme/44": "receta-sipas-temes/baze-flageolet",
  "recipeTheme/45": "receta-sipas-temes/baze-qiqras",
  "recipeTheme/46": "receta-sipas-temes/baze-brokoli",
  "pred-particularite": "kategorite",
  "pred-particularite/Sans%20conservateur": "kategorite/pa-konservues",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "kategorite",
  "pred-particularite/Sans%20colorant": "kategorite/pa-ngyrues",
  "pred-particularite/Sans%20sucre%20ajout%E9": "kategorite/pa-seqer-te-stuar",
  "pred-particularite/Sans%20sel%20ajout%E9": "kategorite/pa-kripe-te-stuar",
  "pred-particularite/Sans%20additif": "kategorite/pa-stesa",
  "pred-particularite/": "kategorite/kripe-e-pranisme-natyrsem",
  "pred-particularite/Sans%20lactose": "kategorite/pa-laktoze",
  "pred-particularite/Sans%20gluten": "kategorite/pa-gluten",
  "pred-particularite/V%E9g%E9tarien": "kategorite/vegetariane",
  "pred-particularite/V%E9g%E9talien": "kategorite/vegane",
  "pred-particularite/Sans%20sulfite": "kategorite/pa-sulfite",
  "pred-particularite/A%20la%20vapeur": "kategorite/avull",
  "pred-particularite/Sans%20condiment": "kategorite/pa-ereza",
  "cultureType": "lloji-i-kultures",
  "cultureType/Bio": "lloji-i-kultures/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "lloji-i-kultures/pa-mbetje-pesticides",
  "cultureType/Sans%20OGM": "lloji-i-kultures/jo-omg",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "kategorite/vegane",
  "pred-particularite/recipeVeggie": "kategorite/vegetariane",
  "pred-particularite/recipeGlutenfree": "kategorite/pa-gluten",
  "pred-particularite/recipeLactosefree": "kategorite/pa-laktoze",
  "cultureOrigin": "origina-e-kultures",
  "cultureOrigin/31": "origina-e-kultures/azerbajxan",
  "cultureOrigin/32": "origina-e-kultures/argentine",
  "cultureOrigin/36": "origina-e-kultures/australi",
  "cultureOrigin/40": "origina-e-kultures/austri",
  "cultureOrigin/51": "origina-e-kultures/armeni",
  "cultureOrigin/56": "origina-e-kultures/belgike",
  "cultureOrigin/68": "origina-e-kultures/bolivi",
  "cultureOrigin/70": "origina-e-kultures/bosne-de-hercegovina",
  "cultureOrigin/76": "origina-e-kultures/brazil",
  "cultureOrigin/97": "origina-e-kultures/baskimi-evropian",
  "cultureOrigin/100": "origina-e-kultures/bullgari",
  "cultureOrigin/104": "origina-e-kultures/birmani",
  "cultureOrigin/120": "origina-e-kultures/kamerun",
  "cultureOrigin/124": "origina-e-kultures/kanada",
  "cultureOrigin/152": "origina-e-kultures/kili",
  "cultureOrigin/156": "origina-e-kultures/kine",
  "cultureOrigin/188": "origina-e-kultures/kosta-rika",
  "cultureOrigin/191": "origina-e-kultures/kroaci",
  "cultureOrigin/196": "origina-e-kultures/qipro",
  "cultureOrigin/203": "origina-e-kultures/republika-ceke",
  "cultureOrigin/208": "origina-e-kultures/danimarke",
  "cultureOrigin/231": "origina-e-kultures/etiopi",
  "cultureOrigin/233": "origina-e-kultures/estoni",
  "cultureOrigin/246": "origina-e-kultures/finlande",
  "cultureOrigin/250": "origina-e-kultures/france",
  "cultureOrigin/258": "origina-e-kultures/polinezia-franceze",
  "cultureOrigin/276": "origina-e-kultures/germani",
  "cultureOrigin/300": "origina-e-kultures/greqi",
  "cultureOrigin/320": "origina-e-kultures/guatemale",
  "cultureOrigin/344": "origina-e-kultures/hong-kong",
  "cultureOrigin/348": "origina-e-kultures/hungari",
  "cultureOrigin/352": "origina-e-kultures/islande",
  "cultureOrigin/356": "origina-e-kultures/indite",
  "cultureOrigin/360": "origina-e-kultures/indonezi",
  "cultureOrigin/372": "origina-e-kultures/irlande",
  "cultureOrigin/376": "origina-e-kultures/izrael",
  "cultureOrigin/380": "origina-e-kultures/itali",
  "cultureOrigin/398": "origina-e-kultures/kazakistan",
  "cultureOrigin/404": "origina-e-kultures/kenia",
  "cultureOrigin/414": "origina-e-kultures/kuvajt",
  "cultureOrigin/417": "origina-e-kultures/kirgistan",
  "cultureOrigin/422": "origina-e-kultures/liban",
  "cultureOrigin/428": "origina-e-kultures/letoni",
  "cultureOrigin/440": "origina-e-kultures/lituani",
  "cultureOrigin/442": "origina-e-kultures/luksemburg",
  "cultureOrigin/450": "origina-e-kultures/madagaskar",
  "cultureOrigin/470": "origina-e-kultures/malte",
  "cultureOrigin/480": "origina-e-kultures/mauritius",
  "cultureOrigin/484": "origina-e-kultures/meksike",
  "cultureOrigin/498": "origina-e-kultures/moldavi",
  "cultureOrigin/499": "origina-e-kultures/mal-i-zi",
  "cultureOrigin/504": "origina-e-kultures/marok",
  "cultureOrigin/528": "origina-e-kultures/vendet-e-uleta",
  "cultureOrigin/548": "origina-e-kultures/vanuatu",
  "cultureOrigin/578": "origina-e-kultures/norvegi",
  "cultureOrigin/586": "origina-e-kultures/pakistan",
  "cultureOrigin/604": "origina-e-kultures/peru",
  "cultureOrigin/616": "origina-e-kultures/poloni",
  "cultureOrigin/620": "origina-e-kultures/portugali",
  "cultureOrigin/634": "origina-e-kultures/katar",
  "cultureOrigin/642": "origina-e-kultures/rumani",
  "cultureOrigin/643": "origina-e-kultures/rusi",
  "cultureOrigin/703": "origina-e-kultures/sllovaki",
  "cultureOrigin/704": "origina-e-kultures/vietnam",
  "cultureOrigin/705": "origina-e-kultures/slloveni",
  "cultureOrigin/724": "origina-e-kultures/spane",
  "cultureOrigin/752": "origina-e-kultures/suedi",
  "cultureOrigin/756": "origina-e-kultures/zvicer",
  "cultureOrigin/764": "origina-e-kultures/tailande",
  "cultureOrigin/784": "origina-e-kultures/emiratet-e-baskuara-arabe",
  "cultureOrigin/792": "origina-e-kultures/turqi",
  "cultureOrigin/795": "origina-e-kultures/turkmenistan",
  "cultureOrigin/804": "origina-e-kultures/ukraine",
  "cultureOrigin/818": "origina-e-kultures/egipt",
  "cultureOrigin/826": "origina-e-kultures/mbreteri-e-baskuar",
  "cultureOrigin/834": "origina-e-kultures/tanzani",
  "cultureOrigin/840": "origina-e-kultures/stetet-e-baskuara",
  "cultureOrigin/999": "origina-e-kultures/eksport",
  "cultureOrigin/NON_EU": "origina-e-kultures/jo-be",
  "cultureOrigin/UE": "origina-e-kultures/be",
  "cultureOrigin/XXX": "origina-e-kultures/bos"
};
